//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import betting from '~/plugins/betting'
const querystring = require('querystring')
import structuredClone from '@ungap/structured-clone';

function toFixed(num, fixed = 2) {
  var re = new RegExp('^-?\\d+(?:.\\d{0,' + (fixed || -1) + '})?')
  return parseFloat(num.toString().match(re)[0])
}
export default {
  components: {},
  data() {
    return {
      max_win: 25000,
      max_win_reached: false,
      max_win_message: '',
      combo_boost_optin_message: '',
      tickets: [],
      each_way: false,
      systemBetSelection: null,
      systemBetChoices: [],
      freebetOptions: [],
      freebetCode: '',
      config: {
        spinner: true,
        step: 1,
        min: 0,
        max: 1100,
        precision: 2,
        decimal: '.',
        thousands: ',',
        bootstrap: false,
        amend: false,
        masked: true
      },
      loading: false
    }
  },
  props: ['mini'],
  watch: {
    selections: function (newSelections, oldSelections) {
      console.log('selections', _.size(newSelections), _.size(oldSelections))
      if (_.size(newSelections) === _.size(oldSelections)) {
        //return;
      }
      if (_.size(newSelections) > _.size(oldSelections)) {
        if (this.betType === 'single' && this.selections.length > 1) {
          let dup_events = _.map(this.selections, 'event.id').reduce((acc, v, i, arr) => (arr.indexOf(v) !== i && acc.indexOf(v) === -1 ? acc.concat(v) : acc), [])
          if (dup_events == 0) {
            this.selectBetType('combi')
          }
        }
      }
      if (this.betType === 'system') {
        if (_.size(newSelections) !== _.size(oldSelections)) {
          this.calculateSystemBets()
        } else {
          //this.calculateSystemBets()
        }
      }
      if (this.selections.length <= 2 && this.betType === 'system') {
        this.selectBetType('single')
      }
      if (this.selections.length === 1) {
        this.selectBetType('single')
      }
      if (this.selections.length > 16 && this.betType === 'system') {
        this.selectBetType('single')
      }
    }
  },
  mounted() {
    this.max_win_message = 'Las ganancias máximas alcanzables puede ser limitadas debido a nuestros términos y condiciones.'
    let lastUpdate = _.get(this.$store.state, 'betslip.updatedAt')
    if (lastUpdate && dayjs().diff(dayjs(lastUpdate), 'hour') > 24) {
      this.$store.commit('betslip/clear')
    }
    this.$store.commit('betslip/setError', null)

    if (this.betType === 'system') {
      this.selectBetType('system')
    }

    if (tock.active('betslip')) {
      tock.clear('betslip')
    }
    tock.setInterval(
      'betslip',
      () => {
        this.updateSelections()
      },
      5 * 1000
    )

    this.fetchFreebets()
    this.$root.$on('selection_added', () => {
      this.updateSelections()
    })
    this.$root.$on('refresh_freebets', () => {
      this.fetchFreebets()
    })
    this.$root.$on('logged_in', () => {
      this.fetchFreebets()
    })
  },
  computed: {
    combo_boost_notice() {
      if (!this.combo_boost_config)
        return false
      return  !!(this.betType === 'combi' && this.combo_boost_selections >= 1 && this.combo_boost_percentage === 0);
    },
    combo_boost_percentage() {
      if (!this.combo_boost_config)
        return 0
      const percent_steps = this.combo_boost_config?.percent_steps || [0];
      let boost_percentage = 0;
      for (let i = 0; i < percent_steps.length; i++) {
        if (this.combo_boost_selections >= i) {
          boost_percentage = parseInt(percent_steps[i]);
        }
      }
      return boost_percentage;
    },
    combo_boost_selections() {
      if (this.betType !== 'combi' || this.is_each_way) {
        // If the conditions for combo boost are not met, return 0 immediately
        return 0;
      }

      // Count the selections where combo_boost_available is true
      return this.selections_live.reduce((count, selection) => {
        return count + (selection.outcome.combo_boost_available ? 1 : 0);
      }, 0);
    },
    combo_boost_config() {
      return this.$store.state.settings.comboBoost
    },
    show_combo_boost_optin() {
      return !!(this.user && !this.combo_boost_optin && (this.combo_boost_percentage > 0));
    },
    combo_boost_optin() {
      if (!this.user) {
        return false;
      }
      return !!this.user.combo_boost_optin;
    },
    accept_odds() {
      return this.$store.state.settings.acceptOdds
    },
    lowest_odds() {
      return _.min(_.map(this.selections, 'outcome.odds'))
    },
    freebet_enabled() {
        if(this.freebetOptions && this.freebetOptions.length) {
          if(this.betType === 'system') {
            return false;
          }
          if(this.betType === 'single' && this.selections.length > 1) {
            return false;
          }
          if (this.betType === 'single' && this.selections.length === 1) {
            if(_.map(this.selections, 'outcome.is_each_way').filter(Boolean).length) return false;
          }
          if (this.betType === 'combi' && this.is_each_way) {
            return false;
          }
          return true;
        }

        return false;
    },
    is_each_way() {
      if (!this.selections_contain_eachway) {
        return false
      }
      if (this.betType === 'single') {
        return false
      }
      return this.each_way
    },
    freebet() {
      if (this.betType === 'single' && this.selections.length === 1) {
        if(_.map(this.selections, 'outcome.is_each_way').filter(Boolean).length) return null;
      }
      if (this.betType === 'single' && this.selections.length > 1) return null
      let freebet = _.find(this.freebetOptions, { id: parseInt(this.freebetCode) })
      if (freebet) return freebet
      return null
    },
    showResults() {
      if (this.processingStatus) return true
      return false
    },
    stakeSingle: {
      get() {
        //if we have other stakes
        return this.$store.state.betslip.stakeSingle
      },
      set(value) {
        this.$store.commit('betslip/setStakesBatch', value)
        this.$store.commit('betslip/setStakeSingle', value)
      }
    },
    stakeCombi: {
      get() {
        //if we have other stakes
        return this.$store.state.betslip.stakeCombi
      },
      set(value) {
        this.$store.commit('betslip/setStakeCombi', value)
      }
    },
    stakeSystem: {
      get() {
        //if we have other stakes
        return this.$store.state.betslip.stakeSystem
      },
      set(value) {
        this.$store.commit('betslip/setStakeSystem', value)
      }
    },
    betType: {
      get() {
        return this.$store.state.betslip.betType
      },
      set(value) {
        this.$store.commit('betslip/setBetType', value)
      }
    },
    selectionsLive: {
      get() {
        return this.$store.state.betslip.selectionsLive
      },
      set(value) {
        this.$store.commit('betslip/setSelectionsLive', value)
      }
    },
    processingStatus: {
      get() {
        return this.$store.state.betslip.processingStatus
      },
      set(value) {
        this.$store.commit('betslip/setProcessingStatus', value)
      }
    },
    total_odds() {
      let total = 0
      if (this.betType === 'combi') {
        total = this.selections_live.reduce((accumulator, selection) => {
          let current_return = 0
          if (_.get(selection, 'outcome.has_ew') && this.is_each_way) {
            current_return = parseFloat(_.get(selection, 'outcome.odds')) + parseFloat(_.get(selection, 'outcome.place_odds'))
          } else {
            current_return = parseFloat(_.get(selection, 'outcome.odds'))
          }
          if(current_return == 0)
            current_return = 1
          return accumulator * current_return
        }, 1)
        total = this.$sportify().sportsbook.formatOdds(total, _.get(this.$store.state, 'settings.oddsFormat', 'decimal'))
      }

      return total
    },
    total_return() {
      let selections = this.selections_live
      let total_stake = this.total_stake
      let freebet_stake = 0
      let freebet_remaining = parseInt(_.get(this.freebet, 'amount_remaining')) / 100
      this.max_win_reached = false
      if (freebet_remaining) {
        total_stake = _.clone(freebet_remaining)
        freebet_stake = _.clone(freebet_remaining)
        console.log('freebet_remaining', freebet_remaining)
        if (total_stake <= freebet_remaining) {
          //freebet_stake = _.clone(total_stake)
        }
        if (total_stake > freebet_remaining) {
          //freebet_stake = total_stake - freebet_remaining
        }
        //freebet_stake = Math.max(0, freebet_stake)
        console.log('freebet_stake', freebet_stake)
      }
      let starting_price_count = selections.reduce((accumulator, selection) => {
        return accumulator + +_.get(selection, 'outcome.is_starting_price', 0)
      }, 0)
      if (starting_price_count > 0) {
        return '-'
      }
      let invalid_odds = selections.reduce((accumulator, selection) => {
        return accumulator * (parseInt(_.get(selection, 'outcome.odds', 0)) > 0 ? 1 : 0)
      }, 1)
      if (invalid_odds == 0) {
        return '-'
      }

      let total = 0
      if (this.betType === 'single') {
        total = selections.reduce((accumulator, selection) => {
          let current_return = 0
          let stake = parseFloat(_.get(this.$store.state.betslip, 'stakes.' + _.get(selection, 'outcome.id'), this.stakeSingle))
          if (_.isNaN(stake)) {
            stake = 0
          }
          if (freebet_remaining) {
            stake = total_stake
          }
          if (_.get(selection, 'outcome.is_each_way')) {
            let win_portion = parseFloat(_.get(selection, 'outcome.odds')) * stake;
            let place_portion = ((win_portion-stake) / parseFloat(_.get(selection, 'market.ew_price'))) + stake;
            console.log('place_portion', place_portion)
            current_return = win_portion + place_portion
            //current_return = parseFloat(_.get(selection, 'outcome.odds')) * stake + parseFloat(_.get(selection, 'outcome.place_odds')) * stake
          } else {
            current_return = parseFloat(_.get(selection, 'outcome.odds')) * stake
          }
          if (accumulator + current_return > this.max_win) {
            console.log('accumulator + current_return',accumulator + current_return)
            this.max_win_reached = true;
          }
          return accumulator + current_return
        }, 0)
      }
      if (this.betType === 'combi') {
        // console.log('--55--');
        let stake = _.clone(this.stakeCombi)
        if(this.is_each_way) {
           let win_portion = 0;
           let place_portion = 0;

            win_portion = selections.reduce((accumulator, selection) => {
              let current_return = parseFloat(_.get(selection, 'outcome.odds'))
              return accumulator * current_return
            }, 1)
            place_portion = selections.reduce((accumulator, selection) => {
              let odds = parseFloat(_.get(selection, 'outcome.odds'));
              let ew_price = parseFloat(_.get(selection, 'market.ew_price'));
              let current_return = ((odds-1)/ew_price) + 1;
              return accumulator * current_return
            }, 1)
            total = (win_portion * stake) + (place_portion * stake)
        } else {
          total = selections.reduce((accumulator, selection) => {
            let current_return = parseFloat(_.get(selection, 'outcome.odds'))
            return accumulator * current_return
          }, 1)

          if (freebet_remaining) {
            stake = freebet_remaining
          }
          total = total * stake
          if(this.combo_boost_percentage && this.combo_boost_optin) {
            const mode = _.get(this.combo_boost_config, 'winnings_calc_mode');
            if (mode === 'gross') {
              total = total + (total * (this.combo_boost_percentage / 100));
            } else if (mode === 'net') {
              total = total + ((total - stake) * (this.combo_boost_percentage / 100));
            }
          }
        }
      }
      if (this.betType === 'system') {
        let stake = _.clone(this.stakeSystem)
        if (freebet_remaining) {
          stake = toFixed(freebet_remaining / this.total_bets)
        }

        if(this.is_each_way) {
          total = _.get(this.systemBetSelection, 'potential_return', 0) * stake
        } else {
          total = _.get(this.systemBetSelection, 'potential_return', 0) * stake
        }
      }

      if (_.get(this.freebet, 'amount_remaining') > 0) {
        total = total - freebet_stake
      }

      //round
      total = -Math.round(-total * 100) / 100
      //total = Math.floor(total * 100) / 100
      if(total > this.max_win) {
        this.max_win_reached = true;
      }
      return total
    },
    can_place_bet() {
      for (let selection of this.selections) {
        //console.log('can_place_bet', selection);
        if (_.get(selection, 'error')) {
          return false
        }
        if (_.get(selection, 'market.is_suspended')) {
          return false
        }
      }

      if (_.get(this.user, 'balance') <= 0 && !this.freebet) {
        return false
      }
      if (this.total_stake <= 0) {
        if (_.get(this.freebet, 'amount_remaining') > 0) {
          return true
        }
        return false
      }
      return true
    },
    total_stake_display() {
      let total = this.total_stake
      if (this.is_each_way) {
        total = total * 2
      }
      if (_.get(this.freebet, 'amount_remaining')) {
        total = Math.max(0, total - _.get(this.freebet, 'amount_remaining') / 100)
        total = 0
      }
      return total
    },
    total_stake() {
      let total = this.stake
      if (this.betType === 'single') {
        total = this.selections.reduce((accumulator, selection) => {
          let stake = parseFloat(_.get(this.$store.state.betslip, 'stakes.' + _.get(selection, 'outcome.id'), this.stake))
          if (_.isNaN(stake)) {
            stake = 0
          }
          if (_.get(selection, 'outcome.is_each_way')) {
            stake = stake * 2
          }
          return accumulator + stake
        }, 0)
      }
      if (this.betType === 'combi') {
        total = this.stakeCombi
      }
      if (this.betType === 'system') {
        total = _.get(this.systemBetSelection, 'combinations', 0) * this.stakeSystem
      }

      return total
    },
    total_bets() {
      if (this.betType === 'single') {
        return _.size(this.$store.state.betslip.selections)
      }
      if (this.betType === 'combi') {
        return 1
      }
      if (this.betType === 'system') {
        return _.get(this.systemBetSelection, 'combinations', 0)
      }
    },
    selections_contain_eachway() {
      let has_ew = false
      this.selections.map((selection) => {
        if (_.get(selection, 'market.ew_place')) {
          has_ew = true
        } else {
          has_ew = false;
        }
      })
      return has_ew
    },
    selections_contain_only_eachway() {
      let has_ew = true
      this.selections.map((selection) => {
        if (_.get(selection, 'market.ew_place') && has_ew) {
          has_ew = true
        } else {
          has_ew = false;
        }
      })
      return has_ew
    },
    selections() {
      let selections = _.cloneDeep(this.$store.state.betslip.selections)
      let betType = _.clone(this.betType)

      let dup_events = _.map(selections, 'event.id').reduce((acc, v, i, arr) => (arr.indexOf(v) !== i && acc.indexOf(v) === -1 ? acc.concat(v) : acc), [])
      selections.map((selection) => {
        selection.error = null
        if (betType === 'combi' || betType === 'system') {
          if (_.includes(dup_events, _.get(selection, 'event.id'))) {
            selection.error = 'CANNOT_COMBINE'
          }
          if ( _.get(selection, 'market.type', '').includes("cast") ) {
            selection.error = 'FORECAST_TRICAST_CANNOT_BE_COMBINED'
          }
        }
        return selection
      })

      try {
        if (this.selectionsLive) {
          selections.map((selection) => {
            if (_.has(this.selectionsLive, selection.outcome.id + '.odds')) {
              //selection.outcome.odds = _.get(this.selectionsLive, selection.outcome.id + '.odds')
              selection.market.is_suspended = _.get(this.selectionsLive, selection.outcome.id + '.is_suspended')
            }
            return selection
          })
        }
      } catch (e) {}

      return selections
    },
    selections_live() {
      let selections = structuredClone(this.$store.state.betslip.selections)

      try {
        if (this.selectionsLive) {
          selections.map((selection) => {
            if (_.has(this.selectionsLive, selection.outcome.id + '.odds')) {
              selection.outcome.odds = _.get(this.selectionsLive, selection.outcome.id + '.odds')
              selection.market.is_suspended = _.get(this.selectionsLive, selection.outcome.id + '.is_suspended')
              selection.outcome.combo_boost_available = _.get(this.selectionsLive, selection.outcome.id + '.combo_boost_available')
            }
            return selection
          })
        }
      } catch (e) {}

      return selections
    },
    error() {
      return this.$store.state.betslip.error
    },

    show_changed_odds_btn() {
      if (_.get(this.$store.state, 'settings.acceptOdds') === 'all') {
        return false
      }

      let selections = _.map(this.selections, function (selection) {
        return { id: _.get(selection, 'outcome.id'), odds: _.get(selection, 'outcome.odds'), display_odds: _.get(selection, 'outcome.display_odds') }
      })
      //selections = _.keyBy(selections, 'id')

      let selectionsLive = _.map(this.selectionsLive, function (selection) {
        return { id: selection.id, odds: selection.odds, display_odds: selection.display_odds }
      })
      selectionsLive = _.keyBy(selectionsLive, 'id')

      if (_.get(this.$store.state, 'settings.acceptOdds') === 'higher') {
        let decreases = _.filter(selections, (selection) => {
          if (parseFloat(_.get(selection, 'odds')) < parseFloat(_.get(selectionsLive, selection.id + '.odds'))) {
            return true
          }
          return false
        })
        if (_.size(decreases) > 0) return true
      }

      if (_.get(this.$store.state, 'settings.acceptOdds') === 'none') {
        let changes = _.filter(selections, (selection) => {
          if (!_.get(selectionsLive, selection.id + '.odds')) {
            return false
          }
          if (_.get(selection, 'odds') == _.get(selectionsLive, selection.id + '.odds')) {
            return false
          }
          return true
        })
        if (_.size(changes) > 0) return true
      }

      return false
    }
  },
  methods: {
    toggleEachway() {
      this.each_way = !this.each_way;
      if (this.betType === 'system') {
        this.calculateSystemBets();
      }
    },
    changeEW() {
      console.log('is_each_way', this.is_each_way)
      if (this.betType === 'system') {
        this.calculateSystemBets()
      }
    },
    async fetchFreebets() {
      if (!this.user) {
        this.freebetOptions = [];
        this.$store.commit('setFreebetCount', _.size(this.freebetOptions))
        return false
      }

      try {
        const response = await this.$api().get('api/content/freebets/active', { params: { active: true, bookmaker: process.env.BOOKMAKER } })
        this.freebetOptions = _.get(response.data, 'data', [])
        this.$store.commit('setFreebetCount', _.size(this.freebetOptions))
      } catch (e) {
        this.$notyf.error('Something went wrong!')
      }
    },
    changeStake(value) {
      this.$store.commit('betslip/clearStakes')
    },
    async calculateSystemBets() {
      // console.log('calculateSystemBets', _.map(this.selections_live, 'outcome.odds'));
      // console.log('calculateSystemBets selections_live', this.selections_live);
      betting.setSelections(this.selections_live)
      betting.setEachWay(this.is_each_way)
      this.systemBetChoices = betting.generateSystemBetTypes()
      if (!this.systemBetSelection || !_.includes(_.map(this.systemBetChoices, 'type'), _.get(this.systemBetSelection, 'type'))) {
        this.systemBetSelection = _.first(this.systemBetChoices)
      } else {
        this.systemBetSelection = _.find(this.systemBetChoices, { type: _.get(this.systemBetSelection, 'type') })
      }

      await this.systemBetSelected();
    },
    async selectBetType(betType) {
      // console.log('selectBetType', betType)

      if (this.selections.length < 2 && betType === 'combi') {
        this.systemBetSelection = null
        return
      }
      if (this.selections.length <= 2 && betType === 'system') {
        return
      }
      if (this.selections.length > 20 && betType === 'system') {
        await this.selectBetType('single')
        return
      }

      if (betType === 'system') {
        await this.calculateSystemBets()
        this.freebetCode = ''
      }
      this.betType = betType
    },
    async openSettings() {
      this.$modal.show('modal-settings')
    },
    async clear() {
      this.$store.commit('betslip/clear')
      this.$store.commit('betslip/setError', null)
    },
    async close() {
      this.$store.commit('betslip/toggleBetslip', false)
    },
    async closeResults() {
      this.processingStatus = false
    },
    async updateSelections() {
      return new Promise((resolve, reject) => {
        if (_.size(this.selections) == 0) {
          return reject(0)
        }
        let params = {}
        params.lang = this.lang;
        params.ids = _.map(this.selections, (item) => {
          let tmp = {}
          tmp.outcome_id = item.outcome.id
          tmp.event_id = item.event.id
          return tmp
        })
        params.bookmaker = process.env.BOOKMAKER
        console.log("TEST SELECTIONS: ",params)
        this.$sportify().sportsbook.getSelections(params, (response) => {
          this.selectionsLive = _.keyBy(_.get(response, 'selections', []), 'id')

          if (this.betType === 'system') {
            this.calculateSystemBets()
          }
          resolve(this.selectionsLive)
        })
      })
    },
    async acceptOdds(force = false) {
      //go through all selections and change odds and display odds to match those of selectionsLive
      let selections = _.map(_.cloneDeep(this.selections), (selection) => {
        //console.log('acceptOdds', selection);
        if (force || this.accept_odds === 'all' || (this.accept_odds === 'higher' && _.get(this.selectionsLive, _.get(selection, 'outcome.id') + '.odds') > _.set(selection, 'outcome.odds'))) {
          // console.log('acceptOdds--', _.get(selection, 'outcome.odds'));
          selection.outcome.odds = _.get(this.selectionsLive, _.get(selection, 'outcome.id') + '.odds')
          selection.outcome.display_odds = _.get(this.selectionsLive, _.get(selection, 'outcome.id') + '.display_odds')
          //selection = _.set(selection, 'outcome.odds', _.get(this.selectionsLive, _.get(selection, 'outcome.id') + '.odds'))
          //selection = _.set(selection, 'outcome.display_odds', _.get(this.selectionsLive, _.get(selection, '.id') + '.display_odds'))
        }
        return selection
      })
      this.$store.commit('betslip/setSelections', selections)
    },

    async placeSingleBet(ticket) {
      //let stakes = _.cloneDeep(this.$store.state.betslip.stakes);
      //stakes = _.map(stakes, function(s){return s * 100});

      try {
        ticket.accept_odds =  _.get({'all': 'ACCEPT_ANY', 'higher': 'ACCEPT_HIGHER', 'none': 'ACCEPT_NONE'}, _.get(this.$store.state, 'settings.acceptOdds'))
        ticket.device_fingerprint = this.$store.state.deviceFingerprint
        ticket.lang = this.lang;
        const response = await this.$api().$post('/v1/betslip/submit', ticket)
        // console.log(response)
        this.freebetCode = ''
        if (_.get(response, 'status') == true) {
          this.tickets = _.map(this.tickets, (currentTicket) => {
            if (currentTicket.uuid == _.get(response, 'uuid')) {
              currentTicket.status = 'PROCESSED'
            }
            return currentTicket
          })

          //this.$store.commit('betslip/remove')
          //this.$swal(this.$t('Bet placed #' + _.get(response, 'id')))

          // console.log('update_balance')
          this.$root.$emit('update_balance')
          this.processingStatus = 'completed'
          /*setTimeout(() => {
            this.$store.commit('betslip/clear')
            this.$store.commit('betslip/clearStakes')
            this.$store.commit('betslip/setBetType', 'single')
            this.$store.commit('betslip/setStakeSingle', null)
            this.$store.commit('betslip/setStakeCombi', null)
          }, 1000)*/
        } else {
          this.tickets = _.map(this.tickets, (currentTicket) => {
            if (currentTicket.uuid == _.get(ticket, 'uuid')) {
              currentTicket.status = _.get(response, 'message', 'CONNECTION_ERROR')
              currentTicket.error = true;
              currentTicket.error_meta = _.get(response, 'meta.error')
            }
            // console.log('currentTicket', currentTicket);
            return currentTicket
          })
          //this.$store.commit('betslip/setError', _.get(response, 'error'))
        }
      } catch (e) {
        // console.log('placeSingleBet', e.response)
        this.tickets = _.map(this.tickets, (currentTicket) => {
          // console.log('ticket.uuid', currentTicket.uuid, _.get(e.response, 'data.uuid'))
          if (currentTicket.uuid === _.get(e.response, 'data.uuid')) {
            currentTicket.status = _.get(e.response, 'data.message', 'CONNECTION_ERROR')
            currentTicket.error_meta = _.get(e.response, 'data.meta.error')
            currentTicket.error = true;
          } else if(currentTicket.uuid === _.get(ticket, 'uuid')) {
            currentTicket.status = 'SERVER_ERROR';
            currentTicket.error_meta = 'Something went wrong';
            currentTicket.error = true;
          }
          return currentTicket
        })

      }

      await this.fetchFreebets()
      this.$root.$emit('update_freebets')
    },

    async systemBetSelected() {
      betting.setSelections(this.selections_live)
      this.systemBetChoices = betting.calculatePotentialReturn(this.systemBetChoices, this.systemBetSelection, this.each_way)
    },

    async placeBet() {
      await this.updateSelections()
      if (this.accept_odds === 'all' || this.accept_odds === 'higher') {
        await this.acceptOdds()
      }
      if (!this.user) {
        this.openLogin()
        return
      }

      this.$store.commit('betslip/setError', null)
      this.loading = true

      let selections = _.cloneDeep(this.selections)
      let stakes = _.cloneDeep(this.$store.state.betslip.stakes)
      stakes = _.each(stakes, (s, index) => {
        stakes[index] = this.$math().multiply(s, 100)
      })
      selections = _.map(selections, (selections) => {
        selections.stake = this.$math().multiply(selections.stake, 100)
        return selections
      })

      let simple_selections = _.map(selections, function (selections) {
        let item = {}
        item.event_id = _.get(selections, 'event.id')
        item.market_id = _.get(selections, 'outcome.market_id')
        item.outcome_id = _.get(selections, 'outcome.id')
        item.outcome_list = _.map(_.get(selections, 'outcome.items', []), 'id')
        item.odds = _.get(selections, 'outcome.odds')
        item.type = _.get(selections, 'market.type')
        item.each_way = _.get(selections, 'outcome.is_each_way')
        item.is_starting_price = _.get(selections, 'outcome.is_starting_price')
        item.stake = _.get(stakes, item.outcome_id, null)
        return item
      })

      this.$store.commit('betslip/setLastUsedStake', parseFloat(this.total_stake))

      try {
        let params = {
          freebet: _.get(this.freebet, 'id'),
          selections: simple_selections,
          type: this.betType,
          system_type: _.get(this.systemBetSelection, 'type'),
          total_stake: this.$math().multiply(this.total_stake, 100),
          total_bets: this.total_bets,
          total_return: this.total_return,
          each_way: this.is_each_way,
          stakes: stakes,
          lang: this.lang,
          accept_odds: _.get({'all': 'ACCEPT_ANY', 'higher': 'ACCEPT_HIGHER', 'none': 'ACCEPT_NONE'}, _.get(this.$store.state, 'settings.acceptOdds'))
        }

        if (this.betType === 'single') {
          params.stake = this.$math().multiply(this.stake, 100)
        }
        if (this.betType === 'combi') {
          params.stake = this.$math().multiply(this.stakeCombi, 100)
        }
        if (this.betType === 'system') {
          params.stake = this.$math().multiply(this.stakeSystem, 100)
        }

        // console.log('params', params)
        //
        // console.log('post axios', this.$axios.$post)
        // console.log('post api', this.$api().$post)
        this.cancelTokenSource = this.$axios.CancelToken.source()
        this.cancelTokenSource && this.cancelTokenSource.cancel('Operation canceled due to new request.');
        this.cancelTokenSource = this.$axios.CancelToken.source();
        const response = await this.$api().$post('/v1/betslip/calculate', params, {cancelToken: this.cancelTokenSource.token})
        // console.log('calculate', response)

        if (_.get(response, 'status') == true) {
          this.processingStatus = 'processing'
          this.tickets = _.get(response, 'tickets')
          for (const ticket of _.get(response, 'tickets')) {
            // console.log('placeSingleBet', ticket)
            await this.placeSingleBet(ticket)
            // console.log('placeSingleBet', ticket)
          }
          // console.log('placeSingleBet DONE')
          this.processingStatus = 'completed'

        } else {
          this.$store.commit('betslip/setError', _.get(response, 'message'))
        }
      } catch (e) {
        console.log(e)
        let message = _.get(e, 'response.data.message', 'Oops, something went wrong. Please try again later.')
        this.$store.commit('betslip/setError', message)
      }

      await this.fetchFreebets()
      this.loading = false

    }
  }
}
